import { compose } from 'redux';
import { connect } from 'react-redux';
import withAuth from '../../common/WithAuth';
import ProductManagementPreview from '../../pages/ProductManagement/ProductManagementPreview';

const mapStateToProps = (state) => ({
    eventInfo: state.registrationOrganizer.registrationOrganizer.data,
});

const mapDispatchToProps = () => ({});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ProductManagementPreview);
